<template>
  <div
    v-if="!adaptive.isDesktop"
    class="mobile-menu-header"
  >
    <div
      v-if="showBack"
      class="icon"
      @click="back"
    >
      <f-sprite-icon :icon-link="$options.icons.IconBack" />
    </div>
    <div
      class="icon"
      @click.stop="close"
    >
      <f-sprite-icon :icon-link="$options.icons.IconClose" />
    </div>
  </div>
</template>

<script>
import IconBack from '../../assets/icons/back.svg';
import IconClose from '../../assets/icons/close.svg';

export default {
  name: 'mobile-menu-header',

  inject: ['adaptive'],

  icons: {
    IconClose,
    IconBack,
  },

  props: {
    showBack: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    back(e) {
      // Событие обязательно
      this.$emit('back', e);
    },
    close() {
      this.$emit('close');
      this.$nav.hide();
    },
  },
};

</script>

<style lang="scss">
.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  padding: 14px $containerGapMobile;
  line-height: 24px;

  .icon {
    width: 24px;
    height: 24px;
    color: $gray_lu;
  }
}
</style>
